import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { HomeIcon, UserIcon, CalendarIcon, CreditCardIcon } from 'lucide-react';
import ThemeToggle from './ThemeToggle';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <div className="flex flex-col min-h-screen dark:text-gray-100" data-id="element-144">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm py-3 px-4 fixed top-0 left-0 right-0 z-10" data-id="element-145">
        <div className="flex items-center justify-between" data-id="element-146">
          <div className="flex items-center" data-id="element-147">
            <img src="https://via.placeholder.com/40x40?text=BG" alt="Burhani Guards Logo" className="h-8 w-auto mr-2" data-id="element-148" />
            <h1 className="text-lg font-medium text-blue-700 dark:text-blue-400" data-id="element-149">
              Burhani Guards
            </h1>
          </div>
          <div className="flex items-center space-x-3" data-id="element-150">
            <ThemeToggle data-id="element-151" />
            <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center" data-id="element-152">
              <UserIcon className="w-5 h-5 text-blue-700 dark:text-blue-300" data-id="element-153" />
            </div>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1 pt-16 pb-16 bg-gray-50 dark:bg-gray-900" data-id="element-154">
        {children}
      </main>
      {/* Bottom Navigation */}
      <nav className="bg-white dark:bg-gray-800 shadow-lg fixed bottom-0 left-0 right-0 py-2 px-4 z-10" data-id="element-155">
        <div className="flex justify-around items-center" data-id="element-156">
          <Link to="/" className={`flex flex-col items-center p-2 ${isActive('/') ? 'text-blue-700 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-157">
            <HomeIcon className="w-6 h-6" data-id="element-158" />
            <span className="text-xs mt-1" data-id="element-159">Home</span>
          </Link>
          <Link to="/duties" className={`flex flex-col items-center p-2 ${isActive('/duties') ? 'text-blue-700 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-160">
            <CalendarIcon className="w-6 h-6" data-id="element-161" />
            <span className="text-xs mt-1" data-id="element-162">Duties</span>
          </Link>
          <Link to="/lawajam" className={`flex flex-col items-center p-2 ${isActive('/lawajam') ? 'text-blue-700 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-163">
            <CreditCardIcon className="w-6 h-6" data-id="element-164" />
            <span className="text-xs mt-1" data-id="element-165">Lawajam</span>
          </Link>
          <Link to="/profile" className={`flex flex-col items-center p-2 ${isActive('/profile') ? 'text-blue-700 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-166">
            <UserIcon className="w-6 h-6" data-id="element-167" />
            <span className="text-xs mt-1" data-id="element-168">Profile</span>
          </Link>
        </div>
      </nav>
    </div>;
};
export default Layout;